import React, { Component, ComponentType, ReactNode, Suspense } from 'react';
import { CATCH_ERROR } from '../../utils/defaults';
import Loader from '../../web-shared/loader/loader';

interface Props {
  children?: ReactNode;
  fallbackComponent?: ComponentType<{ error?: string }>;
}

export default class SuspenseBoundary extends Component<Props, { error: string }> {
  constructor(props: Props) {
    super(props);
    this.state = { error: '' };
  }

  componentDidCatch = CATCH_ERROR;

  static getDerivedStateFromError = (error: Error) => ({ error: error ? error.message : '' });

  render() {
    const { children, fallbackComponent: Fallback = () => <Loader /> } = this.props;
    const { error } = this.state;
    // KU – don't bother rendering the lazy component if we are on the server
    return globalThis.window && !error ? (
      <Suspense fallback={<Fallback />}>{children}</Suspense>
    ) : (
      <Fallback error={error} />
    );
  }
}
